var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"video",staticStyle:{"object-fit":"fill","width":"100%"},attrs:{"autoplay":"","controls":"","preload":"auto","height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }